import { useState, useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { ForgotIdForm } from 'components/templates/ForgotIdTemplate';
import { FormErrors, initialFormErrors, getErrorMessage } from 'validators/ForgotIdValidator';
import { ForgotIdReqData, callForgotIdApi } from 'requests/RequestUser';
import { ApiError } from 'requests/RequestBase';
import { HttpStatus } from 'consts/HttpStatus';
import { RoutePath } from 'consts/RoutePath';

export const useForgotId = (formData: ForgotIdForm) => {
	const history = useHistory();
	const [formErrors, setFormErrors] = useState<FormErrors>(initialFormErrors);
	const isFormError = !!Object.values(formErrors).find((e) => e !== '');
	const [actionError, setActionError] = useState('');
	const isActionError = actionError !== '';
	const [processLoading, setProcessLoading] = useState(false);

	// recaptcha
	const [isCompleteButtonDisabled, setIsCompleteButtonDisabled] = useState(true);
	const recaptchaRef = useRef(null);
	const onRecaptchaChange = (value) => {
		const isError = value == null || value === '';
		setIsCompleteButtonDisabled(true);
		if (!isError) {
			setFormErrors({ ...formErrors, isNotRobot: '' });
			setIsCompleteButtonDisabled(false);
		}
	};

	const [isFormValidationFinished, setIsFormValidationFinished] = useState(false);
	const requestId = () => {
		setProcessLoading(true);
		setActionError('');

		Object.keys(formErrors).forEach((k) => {
			setFormErrors((prev) => ({ ...prev, [k]: getErrorMessage(k, formData[k]) }));
		});

		setIsFormValidationFinished(true);
	};

	useEffect(() => {
		if (!isFormValidationFinished) {
			return;
		}
		const isError = !!Object.values(formErrors).find((e) => e !== '') || actionError !== '';
		if (isError) {
			setIsFormValidationFinished(false);
			setProcessLoading(false);
			return;
		}

		const execute = async () => {
			setActionError('');
			const reqData: ForgotIdReqData = {
				lastname: formData.lastname,
				firstname: formData.firstname,
				mailaddress: formData.mailaddress,
			};
			const forgotIdResult = await callForgotIdApi(reqData);
			if (forgotIdResult.status !== HttpStatus.OK) {
				const error = forgotIdResult.data as ApiError;
				setIsFormValidationFinished(false);
				setProcessLoading(false);
				setActionError(error?.message);
				return;
			}
			setIsFormValidationFinished(false);
			setProcessLoading(false);
			history.push(RoutePath.FORGOT_ID_CONFIRM, { mailaddress: formData.mailaddress });
		};
		execute();
	}, [isFormValidationFinished]);

	return {
		requestId,
		formErrors,
		isFormError,
		actionError,
		isActionError,
		processLoading,
		isCompleteButtonDisabled,
		recaptchaRef,
		onRecaptchaChange,
	};
};
